import { createSelector } from 'reselect';

const selectAdmin = state => state.admin;


// USERS

export const selectUsers = createSelector(
    [selectAdmin],
    admin => admin.users
)

export const selectAllUsers = createSelector(
    [selectAdmin],
    admin => admin.allUsers
)

export const selectIsFetchingUsers = createSelector(
    [selectAdmin],
    admin => admin.isFetchingUsers
)

export const selectIsFetchingAllUsers = createSelector(
    [selectAdmin],
    admin => admin.isFetchingAllUsers
)

export const selectAdminTab = createSelector(
    [selectAdmin],
    admin => admin.selectedTabAdmin
)

export const selectSearchQuery = createSelector(
    [selectAdmin],
    admin => admin.searchQuery
)

export const selectSearchQueryUsers = createSelector(
    [selectAdmin],
    admin => admin.searchQueryUsers
)

export const selectNumUsers = createSelector(
    [selectAdmin],
    admin => admin.numUsers
)


export const selectSelectedUsers = createSelector(
    [selectAdmin],
    admin => admin.selectedUsers
)


/// DEPARTMENTS

//deprecate department
export const selectDepartments = createSelector(
    [selectAdmin],
    admin => admin.departments
)
export const selectIsFetchingDepartments = createSelector(
    [selectAdmin],
    admin => admin.isFetchingDepartments
)

export const selectIsLoadingDepartments = createSelector( //change for all departments
    [selectAdmin],
    admin => admin.isFetchingDepartments
)

export const selectDepartmentsOnPage = createSelector(
    [selectAdmin],
    admin => admin.departmentsOnPage
)

export const selectSearchDepartmentsQuery = createSelector(
    [selectAdmin],
    admin => admin.searchDepartmentsQuery
)


export const selectSelectedDepartments = createSelector(
    [selectAdmin],
    admin => admin.selectedDepartments
)

export const selectNumDepartments = createSelector(
    [selectAdmin],
    admin => admin.numDepartments
)

/// LOG-ACTIVITY

export const selectLogs = createSelector(
    [selectAdmin],
    admin => admin.logs
)
export const selectNumLogs = createSelector(
    [selectAdmin],
    admin => admin.numLogs
)
export const selectIsFetchingLogs = createSelector(
    [selectAdmin],
    admin => admin.isFetchingLogs
)
export const selectSelectedLogs = createSelector(
    [selectAdmin],
    admin => admin.selectedLogs
)
export const selectSearchLogsQuery = createSelector(
    [selectAdmin],
    admin => admin.searchLogsQuery
)

/// ROLES

export const selectIsFetchingRoles = createSelector(
    [selectAdmin],
    admin => admin.isFetchingRoles
)

export const selectRoles = createSelector(
    [selectAdmin],
    admin => admin.roles
)

export const selectRolesOnPage = createSelector(
    [selectAdmin],
    admin => admin.rolesOnPage
)

export const selectSearchRolesQuery = createSelector(
    [selectAdmin],
    admin => admin.searchRolesQuery
)

export const selectNumRoles = createSelector(
    [selectAdmin],
    admin => admin.numRoles
)

export const selectSelectedRoles = createSelector(
    [selectAdmin],
    admin => admin.selectedRoles
)

// TEMPLATES

export const selectIsFetchingTemplates = createSelector(
    [selectAdmin],
    admin => admin.isFetchingTemplates
)

export const selectTemplates = createSelector(
    [selectAdmin],
    admin => admin.templates
)

export const selectTemplatesOnPage = createSelector(
    [selectAdmin],
    admin => admin.templatesOnPage
)

export const selectSearchTemplatesQuery = createSelector(
    [selectAdmin],
    admin => admin.searchTemplatesQuery
)

export const selectNumTemplates = createSelector(
    [selectAdmin],
    admin => admin.numTemplates
)

export const selectSelectedTemplates = createSelector(
    [selectAdmin],
    admin => admin.selectedTemplates
)

// TEMPLATE TASKS

export const selectIsFetchingTemplateTasks = createSelector(
    [selectAdmin],
    admin => admin.isFetchingTemplateTasks
)

export const selectTemplateTasks = createSelector(
    [selectAdmin],
    admin => admin.templateTasks
)

export const selectTemplateTasksOnPage = createSelector(
    [selectAdmin],
    admin => admin.templateTasksOnPage
)

export const selectSearchTemplateTasksQuery = createSelector(
    [selectAdmin],
    admin => admin.searchTemplateTasksQuery
)

export const selectNumTemplateTasks = createSelector(
    [selectAdmin],
    admin => admin.numTemplateTasks
)

export const selectSelectedTemplateTasks = createSelector(
    [selectAdmin],
    admin => admin.selectedTemplateTasks
)